export default __webpack_public_path__ + "d7693faecf7d62a12320ea657dfdf8ca.svg";